<template>
  <a-layout-content id="resources" class="all-c resources-container">
    <div class="mobile">
      <div class="en" v-show="isEnglish">
        <h2 class="resources-maintitle">{{ $t('resources') }}</h2>
        <ul>
          <li class="s2">
            <img src="../../public/icon/1.svg" style="display: inline-block;" />
            <span class="t2">{{ $t('sensoryStrategies') }}</span> <br />
            {{ getResourceDescription('Sensory Strategies') }}
          </li>
          <li class="s2">
            <img src="../../public/icon/2.svg" style="display: inline-block;" />
            <span class="t2">{{ $t('selfRegulation') }}</span> <br />
            {{ getResourceDescription('Self-Regulation') }}
          </li>
          <li class="s2">
            <img src="../../public/icon/3.svg" style="display: inline-block;" />
            <span class="t2">{{ $t('handwriting') }}</span> <br />
            {{ getResourceDescription('Handwriting') }}
          </li>
          <li class="s2">
            <img src="../../public/icon/4.svg" style="display: inline-block;" />
            <span class="t2">{{ $t('fineMotorSkills') }}</span> <br />
            {{ getResourceDescription('Fine Motor Skills') }}
          </li>
          <li class="s2">
            <img src="../../public/icon/5.svg" style="display: inline-block;" />
            <span class="t2">{{ $t('visualMotorIntegration') }}</span> <br />
            {{ getResourceDescription('Visual Motor Integration') }}
          </li>
          <li class="s2">
            <img src="../../public/icon/6.svg" style="display: inline-block;" />
            <span class="t2">{{ $t('visualPerception') }}</span> <br />
            {{ getResourceDescription('Visual Perception') }}
          </li>
          <li class="s2">
            <img src="../../public/icon/7.svg" style="display: inline-block;" />
            <span class="t2">{{ $t('grossMotorAndBilateralCoordination') }}</span> <br />
            {{ getResourceDescription('Gross Motor and Bilateral Coordination') }}
          </li>
          <li class="s2">
            <img src="../../public/icon/8.svg" style="display: inline-block;" />
            <span class="t2">{{ $t('selfCare') }}</span> <br />
            {{ getResourceDescription('Self-Care') }}
          </li>
          <li class="s2">
            <img src="../../public/icon/9.svg" style="display: inline-block;" />
            <span class="t2">{{ $t('learningDifficulties') }}</span> <br />
            {{ getResourceDescription('Learning Difficulties') }}
          </li>
          <li class="s2">
            <img src="../../public/icon/10.svg" style="display: inline-block;" />
            <span class="t2">{{ $t('executiveFunction') }}</span> <br />
            {{ getResourceDescription('Executive Function') }}
          </li>
        </ul>
        <div class="resources-footer">
          <p>{{ $t('contactForResources') }}</p>
        </div>
      </div>
      <div class="cn" v-show="!isEnglish">
        <h2 class="resources-maintitle">{{ $t('resources') }}</h2>
        <ul>
          <li class="s2">
            <img src="../../public/icon/1.svg" style="display: inline-block;" />
            <span class="t2">{{ $t('sensoryStrategies') }}</span> <br />
            {{ getResourceDescription('Sensory Strategies') }}
          </li>
          <li class="s2">
            <img src="../../public/icon/2.svg" style="display: inline-block;" />
            <span class="t2">{{ $t('selfRegulation') }}</span> <br />
            {{ getResourceDescription('Self-Regulation') }}
          </li>
          <li class="s2">
            <img src="../../public/icon/3.svg" style="display: inline-block;" />
            <span class="t2">{{ $t('handwriting') }}</span> <br />
            {{ getResourceDescription('Handwriting') }}
          </li>
          <li class="s2">
            <img src="../../public/icon/4.svg" style="display: inline-block;" />
            <span class="t2">{{ $t('fineMotorSkills') }}</span> <br />
            {{ getResourceDescription('Fine Motor Skills') }}
          </li>
          <li class="s2">
            <img src="../../public/icon/5.svg" style="display: inline-block;" />
            <span class="t2">{{ $t('visualMotorIntegration') }}</span> <br />
            {{ getResourceDescription('Visual Motor Integration') }}
          </li>
          <li class="s2">
            <img src="../../public/icon/6.svg" style="display: inline-block;" />
            <span class="t2">{{ $t('visualPerception') }}</span> <br />
            {{ getResourceDescription('Visual Perception') }}
          </li>
          <li class="s2">
            <img src="../../public/icon/7.svg" style="display: inline-block;" />
            <span class="t2">{{ $t('grossMotorAndBilateralCoordination') }}</span> <br />
            {{ getResourceDescription('Gross Motor and Bilateral Coordination') }}
          </li>
          <li class="s2">
            <img src="../../public/icon/8.svg" style="display: inline-block;" />
            <span class="t2">{{ $t('selfCare') }}</span> <br />
            {{ getResourceDescription('Self-Care') }}
          </li>
          <li class="s2">
            <img src="../../public/icon/9.svg" style="display: inline-block;" />
            <span class="t2">{{ $t('learningDifficulties') }}</span> <br />
            {{ getResourceDescription('Learning Difficulties') }}
          </li>
          <li class="s2">
            <img src="../../public/icon/10.svg" style="display: inline-block;" />
            <span class="t2">{{ $t('executiveFunction') }}</span> <br />
            {{ getResourceDescription('Executive Function') }}
          </li>
        </ul>
        <div class="resources-footer">
          <p>{{ $t('contactForResources') }}</p>
        </div>
      </div>
    </div>
    <div class="pc">
      <div class="en" v-show="isEnglish">
        <h2 class="resources-title">{{ $t('resources') }}</h2>
        <h3 class="resources-subtitle entitle">{{ getResourceTitle('Fine Motor Skills') }}</h3>
        <p class="resources-description endesc">{{ getResourceDescription('Fine Motor Skills') }}</p>
        <div class="puzzle-content">
          <div class="puzzle-container">
            <div class="puzzle-item sensory-strategies" name="Sensory Strategies"
              @click="changeResource('Sensory Strategies')"
              :class="{ active: currentResource === 'Sensory Strategies' }">{{ $t('sensoryStrategies') }}</div>
            <div class="puzzle-item self-regulation" name="Self-Regulation" @click="changeResource('Self-Regulation')"
              :class="{ active: currentResource === 'Self-Regulation' }">{{ $t('selfRegulation') }}</div>
            <div class="puzzle-item handwriting" name="Handwriting" @click="changeResource('Handwriting')"
              :class="{ active: currentResource === 'Handwriting' }">{{ $t('handwriting') }}</div>
            <div class="puzzle-item active fine-motor-skills" name="Fine Motor Skills"
              @click="changeResource('Fine Motor Skills')" :class="{ active: currentResource === 'Fine Motor Skills' }">
              {{ $t('fineMotorSkills') }}</div>
            <div class="puzzle-item visual-motor-integration" name="Visual Motor Integration"
              @click="changeResource('Visual Motor Integration')"
              :class="{ active: currentResource === 'Visual Motor Integration' }">{{ $t('visualMotorIntegration') }}
            </div>
            <div class="puzzle-item visual-perception" name="Visual Perception"
              @click="changeResource('Visual Perception')" :class="{ active: currentResource === 'Visual Perception' }">
              {{ $t('visualPerception') }}</div>
            <div class="puzzle-item gross-motor" name="Gross Motor and Bilateral Coordination"
              @click="changeResource('Gross Motor and Bilateral Coordination')"
              :class="{ active: currentResource === 'Gross Motor and Bilateral Coordination' }">{{
        $t('grossMotorAndBilateralCoordination') }}</div>
            <div class="puzzle-item self-care" name="Self-Care" @click="changeResource('Self-Care')"
              :class="{ active: currentResource === 'Self-Care' }">{{ $t('selfCare') }}</div>
            <div class="puzzle-item learning-difficulties" name="Learning Difficulties"
              @click="changeResource('Learning Difficulties')"
              :class="{ active: currentResource === 'Learning Difficulties' }">{{ $t('learningDifficulties') }}</div>
            <div class="puzzle-item executive-function" name="Executive Function"
              @click="changeResource('Executive Function')"
              :class="{ active: currentResource === 'Executive Function' }">{{ $t('executiveFunction') }}</div>
          </div>
          <div class="bg">
            <img class="bg-img" src="../../public/6.png" alt="">
          </div>
        </div>
        <div class="resources-footer">
          <p>{{ $t('contactForResources') }}</p>
        </div>
      </div>
      <!-- 添加中文版本内容 -->
      <div class="cn" v-show="!isEnglish">
        <h2 class="resources-title">{{ $t('resources') }}</h2>
        <h3 class="resources-subtitle cntitle">{{ getResourceTitle('Fine Motor Skills') }}</h3>
        <p class="resources-description cndesc">{{ getResourceDescription('Fine Motor Skills') }}</p>
        <div class="puzzle-content">
          <div class="puzzle-container">
            <div class="puzzle-item sensory-strategies" name="Sensory Strategies"
              @click="changeResource('Sensory Strategies')"
              :class="{ active: currentResource === 'Sensory Strategies' }">{{ $t('sensoryStrategies') }}</div>
            <div class="puzzle-item self-regulation" name="Self-Regulation" @click="changeResource('Self-Regulation')"
              :class="{ active: currentResource === 'Self-Regulation' }">{{ $t('selfRegulation') }}</div>
            <div class="puzzle-item handwriting" name="Handwriting" @click="changeResource('Handwriting')"
              :class="{ active: currentResource === 'Handwriting' }">{{ $t('handwriting') }}</div>

            <div class="puzzle-item active fine-motor-skills" name="Fine Motor Skills"
              @click="changeResource('Fine Motor Skills')" :class="{ active: currentResource === 'Fine Motor Skills' }">
              {{ $t('fineMotorSkills') }}</div>
            <div class="puzzle-item visual-motor-integration" name="Visual Motor Integration"
              @click="changeResource('Visual Motor Integration')"
              :class="{ active: currentResource === 'Visual Motor Integration' }">{{ $t('visualMotorIntegration') }}
            </div>
            <div class="puzzle-item visual-perception" name="Visual Perception"
              @click="changeResource('Visual Perception')" :class="{ active: currentResource === 'Visual Perception' }">
              {{ $t('visualPerception') }}</div>
            <div class="puzzle-item gross-motor" name="Gross Motor and Bilateral Coordination"
              @click="changeResource('Gross Motor and Bilateral Coordination')"
              :class="{ active: currentResource === 'Gross Motor and Bilateral Coordination' }">{{
        $t('grossMotorAndBilateralCoordination') }}</div>
            <div class="puzzle-item self-care" name="Self-Care" @click="changeResource('Self-Care')"
              :class="{ active: currentResource === 'Self-Care' }">{{ $t('selfCare') }}</div>
            <div class="puzzle-item learning-difficulties" name="Learning Difficulties"
              @click="changeResource('Learning Difficulties')"
              :class="{ active: currentResource === 'Learning Difficulties' }">{{ $t('learningDifficulties') }}</div>
            <div class="puzzle-item executive-function" name="Executive Function"
              @click="changeResource('Executive Function')"
              :class="{ active: currentResource === 'Executive Function' }">{{ $t('executiveFunction') }}</div>
          </div>
          <div class="bg">
            <img class="bg-img" src="../../public/6.png" alt="">
          </div>
        </div>
        <div class="resources-footer">
          <p>{{ $t('contactForResources') }}</p>
        </div>
      </div>
    </div>
  </a-layout-content>
</template>

<script>
export default {
  data() {
    return {
      isEnglish: true,
      currentResource: 'Fine Motor Skills',
      resourceDescriptions: {
        "Fine Motor Skills": {
          "en": {
            "title": "Fine Motor Skills",
            "desc": "Fine motor Skills involve the small muscles of the hands and fingers, essential for \n" +
              "tasks like grasping, manipulating materials and supplies, and using keyboard. \n" +
              "Our activities support the development of strength, coordination, and \n" +
              "dexterity to help children complete these daily tasks and play with confidence."
          },
          "cn": {
            "title": "精细运动技能",
            "desc": "精细运动技能是指手部和手指的小肌肉活动，这些技能对抓握、操控物品、使用键盘等任务至关重要。\n" +
              "我们的干预活动旨在提升儿童的手部力量、协调性和灵活性，帮助他们自信地完成日常任务和参与游戏。"
          }
        },
        "Handwriting": {
          "en": {
            "title": "Handwriting",
            "desc": "Handwriting is more than just forming letters; it requires coordination, control, and practice. Through fun and engaging activities, we work on letter formation, spacing, and pressure control, helping children feel more at ease and successful with writing."
          },
          "cn": {
            "title": "书写",
            "desc": "书写不仅仅是形成字母；它需要协调、控制和练习。通过趣味性和互动性的活动，我们专注于字母的书写形成、间距以及力度控制，帮助孩子在书写时更加自信和从容，取得更大的成功。"
          }
        },
        "Visual Perception": {
          "en": {
            "title": "Visual Perception",
            "desc": "Visual perception is the ability to interpret and understand visual information. Our activities support skills like recognizing patterns, differentiating shapes, and understanding spatial relationships, laying a strong foundation for reading, math, and everyday tasks."
          },
          "cn": {
            "title": "视觉感知",
            "desc": "视觉感知是指解读和理解视觉信息的能力。 我们的活动旨在帮助孩子提升例如识别图案、区分形状和理解空间关系的能力，为阅读、数学及日常任务打下坚实基础。"
          }
        },
        "Visual Motor Integration": {
          "en": {
            "title": "Visual Motor Integration",
            "desc": "Visual motor integration is about combining visual and motor skills to complete tasks like drawing, cutting, or copying from a board. By strengthening these skills, we help children improve their ability to process visual information and translate it into smooth, controlled movements."
          },
          "cn": {
            "title": "视觉运动整合",
            "desc": "视觉运动整合是指将视觉和运动技能结合起来，完成绘图、剪纸或抄写黑板上内容等任务。通过加强这些技能，我们帮助孩子们提高处理视觉信息的能力，并将其转化为流畅、可控的动作。"
          }
        },
        "Self-Regulation": {
          "en": {
            "title": "Self-Regulation",
            "desc": "Self-regulation allows children to manage their emotions, behaviors, and attention. Our sessions provide practical strategies to help children identify their emotions, adjust their responses, and build the self-control needed for social situations and school success."
          },
          "cn": {
            "title": "自我调节",
            "desc": "自我调节是指孩子管理情绪、行为和注意力的能力。 我们的课程提供实用策略，帮助孩子识别情绪、调整反应，并培养社交场合和学业成功所需的自控力。"
          }
        },
        "Sensory Strategies": {
          "en": {
            "title": "Sensory Strategies",
            "desc": "Sensory processing is key to how children interpret and respond to the world. We provide individualized sensory strategies to help children manage sensitivities, improve focus, and stay calm in different environments, enabling them to participate more fully in everyday life."
          },
          "cn": {
            "title": "感觉策略",
            "desc": "感觉处理是孩子解读和应对世界的关键能力。 我们提供个性化的感觉策略，帮助孩子管理敏感性、提升专注力，并在不同环境中保持平静，从而更全面充分地参与日常生活。"
          }
        },
        "Gross Motor and Bilateral Coordination": {
          "en": {
            "title": "Gross Motor and Bilateral Coordination",
            "desc": "Gross motor skills involve larger muscle groups needed for activities like running, jumping, and climbing, while bilateral coordination allows both sides of the body to work together. Our activities help children build strength, balance, and coordination to enhance their confidence and mobility."
          },
          "cn": {
            "title": "大运动和双侧协调",
            "desc": "大运动技能涉及跑步、跳跃和攀爬等活动所需的较大肌肉群，而双侧协调使身体两侧能够协同工作。我们的活动帮助孩子们建立力量、平衡和协调能力，以增强他们的信心和行动能力。"
          }
        },
        "Executive Function": {
          "en": {
            "title": "Executive Function",
            "desc": "Executive function skills help children learn new knowledge, retrieve information they learned in the past, use information, plan, organize, and complete tasks effectively. We offer activities that build memory, attention, problem-solving, time management, impulse control skills, equipping children with tools for better decision-making and task management."
          },
          "cn": {
            "title": "执行功能",
            "desc": "执行功能技能让孩子学习新知识、提取以往记忆、有效运用信息、计划、组织并高效完成任务。 我们通过设计活动，培养孩子的记忆力、专注力、问题解决能力、时间管理能力和冲动控制能力，赋予他们更好的决策和任务管理工具。"
          }
        },
        "Self-Care": {
          "en": {
            "title": "Self-Care",
            "desc": "Self-care skills like dressing, feeding, and hygiene are crucial for independence. We help children learn and practice these routines step-by-step, empowering them to manage daily life tasks with more ease."
          },
          "cn": {
            "title": "生活自理",
            "desc": "自理技能，例如穿衣、进食和个人卫生，是独立生活的重要基础。 我们通过逐步指导和练习，帮助孩子掌握这些日常生活技能，使他们能够更加从容地应对日常任务。"
          }
        },
        "Learning Difficulties": {
          "en": {
            "title": "Learning Difficulties",
            "desc": "For children with learning difficulties, personalized support can make a world of difference. We provide structured activities that address specific learning challenges, aiming to build confidence and skills to help each child achieve their potential."
          },
          "cn": {
            "title": "学习困难",
            "desc": "对于有学习困难的孩子，个性化的支持能带来巨大的改变。我们提供结构化活动，针对孩子的特定学习挑战，旨在培养自信和技能，帮助每个孩子实现他们的潜力。"
          }
        },
      }
    };
  },
  methods: {
    getResourceTitle() {
      console.log(this.currentResource, this.resourceDescriptions[this.currentResource])
      return this.resourceDescriptions[this.currentResource][this.isEnglish ? 'en' : 'cn'].title;
    },
    getResourceDescription(type) {
      // 如果传入了具体类型，则使用传入的类型，否则使用当前选中的资源类型
      const resourceType = type || this.currentResource;
      return this.resourceDescriptions[resourceType][this.isEnglish ? 'en' : 'cn'].desc;
    },
    changeResource(type) {
      this.currentResource = type;
      const titleEn = this.getResourceTitle();
      const descEn = this.getResourceDescription();
      const titleCn = this.getResourceTitle();
      const descCn = this.getResourceDescription();
      const resources_subtitle_en = document.querySelector('.entitle');
      const resources_description_en = document.querySelector('.endesc');
      const resources_subtitle_cn = document.querySelector('.cntitle');
      const resources_description_cn = document.querySelector('.cndesc');
      resources_subtitle_en.textContent = titleEn;
      resources_description_en.textContent = descEn;
      resources_subtitle_cn.textContent = titleCn;
      resources_description_cn.textContent = descCn;
      const puzzle_items = document.querySelectorAll('.puzzle-item');
      puzzle_items.forEach(puzzle_item => puzzle_item.classList.remove('active'));
      document.getElementsByName(type).forEach(puzzle_item => puzzle_item.classList.add('active'));
    },
    getKeyByValue(value) {
      for (let key in this.resourceDescriptions) {
        if (key === value) {
          return this.resourceDescriptions[key].cn.title;
        }
      }
      return null;
    }
  },
  computed: {
    currentLang() {
      return this.$i18n.locale;
    }
  },
  watch: {
    currentLang(newLang) {
      this.isEnglish = newLang === 'en';
    }
  }
};
</script>

<style scoped lang="less">
@mainBg: #f8f5f0;
@mainBg2: #f8f5f1;
@mainColor1: #de94a4;
@mainColor2: #eebac0;
@mainColor3: #A98578;
@mainFont: "MontserratMedium", sans-serif;
@mainFontSub: "MontserratLight", sans-serif;
@mainFontCn: 'Huangchan', sans-serif;

.resources-container {
  height: calc(100vh - 110px);
  color: white;
  font-family: @mainFont;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  .mobile {
    display: none;
  }

  >div {
    width: 75%;

    .resources-title {
      font-size: 2.5vw;
      color: @mainColor3;
      font-weight: 600;
      margin-bottom: 0;
    }

    .cn {
      .resources-title {
        font-family: @mainFontCn;
      }
    }

    .resources-subtitle {
      font-size: 1.9vw;
      color: @mainColor3;
      margin-bottom: 0;
    }

    .cn {
      .resources-subtitle {
        font-family: @mainFontCn;
      }
    }

    .resources-description {
      font-size: 1.5vw;
      color: #333;
      margin-bottom: 1vw;
    }

    .cn .resources-description {
      font-family: @mainFontCn;
    }

    .puzzle-content {
      position: relative;
      margin-bottom: 1vw;

      .puzzle-container {
        /*
          background: rgba(22,35,50,.3);
          */
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        /*
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        grid-template-rows: repeat(2, 1fr);
        gap: 3%;
        */
        &.active {
          color: black;
        }

        .puzzle-item {
          text-align: center;
          font-family: "MontserratMedium", sans-serif;
          font-size: 1.5vw;
          font-weight: bolder;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          transition: transform 0.3s;
          line-height: 1.2;
          box-sizing: border-box;
          padding: 5%;
          width: 20%;
          height: 50%;
          float: left;

          &:hover {
            transform: scale(1.05);
          }

          &.self-regulation {
            padding-bottom: 0;
          }

          &.visual-motor-integration {
            padding-bottom: 8%;
          }

          &.visual-perception {
            padding-right: 12%;
          }

          &.self-care {
            padding: 7%;
          }

          &.executive-function {
            padding-left: 12%;
          }
        }

        .cn {
          font-family: 'Huangchan', sans-serif;
        }
      }

      .bg {
        >img.bg-img {
          width: 100%;
        }
      }
    }

    .resources-footer {
      text-align: left;

      p {
        box-sizing: border-box;
        color: @mainColor3;
        border: 1px solid @mainColor2;
        font-size: 1.2vw;
        line-height: 1.2;
        border-radius: 1.3vw;
        padding: 1vw 2vw;
      }
    }

    &.pc {
      >div.cn {
        font-family: @mainFontCn;

        .puzzle-content {
          .puzzle-container {
            .puzzle-item {
              &.self-regulation {
                padding: 7%;
              }

              &.fine-motor-skills {
                padding: 7%;
              }

              &.visual-motor-integration {
                padding: unset;
              }
              &.visual-perception {
                padding: 7% 10% 7% 4%;
              }
              &.gross-motor {
                padding: unset;
              }
              &.self-care {
                padding: 7%;
              }
              &.executive-function {
                padding: 7% 4% 7% 10%;
              }
            }
          }
        }

        .resources-footer {
          p {
            border-radius: 10vw;
            font-size: 1.3vw;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .resources-container {
    >div {
      width: 85%;

      .resources-maintitle {
        font-size: 5vw;
        color: @mainColor3;
        font-weight: 600;
      }
    }
  }

  .pc {
    display: none !important;
  }

  .mobile {
    display: block !important;
    color: #333;

    .en {
      font-family: @mainFont;
    }

    .cn {
      font-family: @mainFontCn;
    }

    ul {
      padding-top: 6vw;
      margin-left: 0 !important;
      list-style-type: none;
      margin-block-start: 0;
      margin-block-end: 0;
      padding-inline-start: 0;

      /*
      li {
        list-style: none;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 2vw;
        padding: 3;
        .title {
          display: flex ;
          align-items: center;
          gap: 5%;
          border-radius: 3vw;
          img {
            width: 10%;
          }
          p {
            font-size: 3.4vw;
            color: @mainColor3;
            margin-bottom: 0;
            text-align: left;
          }
        }
        .content {
          font-size: 3vw;
          text-align: left;

          padding: 3vw 0 6vw;
          border-radius: 2vw;
        }
        &:nth-child(1),&:nth-child(5),&:nth-child(9) {
          .title {
            p {
              color: #F4C6CC;
            }
          }
        }
        &:nth-child(2),&:nth-child(6) {
          .title {
            p {
              color: #F6DEC7;
            }
          }
        }
        &:nth-child(3),&:nth-child(7) {
          .title {
            p{
              color: #9FBADD;
            }
          }
        }
        &:nth-child(4),&:nth-child(8) {
          .title {
            p{
              color: #E89DAB;
            }
          }
        }
      }
        */
      li.s2 {
        text-align: left;
        line-height: 1.6;
        padding: 5vw;
        border-radius: 3vw;
        margin-bottom: 4vw;
        font-size: 3vw;

        >img {
          width: 10%;
          display: inline-block !important;
          float: left;
          margin: 4vw;
        }

        &::after {
          content: '';
          display: block;
          clear: both;
        }

        .t2 {
          color: #F4C6CC;
          font-size: 3.5vw;
          font-weight: 600;
        }

        &:nth-child(1),
        &:nth-child(5),
        &:nth-child(9) {
          background: rgba(#F4C6CC, 0.1);

          .t2 {
            color: #F4C6CC;
          }
        }

        &:nth-child(2),
        &:nth-child(6),
        &:nth-child(10) {
          background: rgba(#F6DEC7, 0.1);

          .t2 {
            color: #F6DEC7;
          }
        }

        &:nth-child(3),
        &:nth-child(7) {
          background: rgba(#9FBADD, 0.1);

          .t2 {
            color: #9FBADD;
          }
        }

        &:nth-child(4),
        &:nth-child(8) {
          background: rgba(#E89DAB, 0.1);

          .t2 {
            color: #E89DAB;
          }
        }
      }
    }

    .resources-footer {
      padding: 2vw;

      p {
        border-radius: 3vw;
        font-size: 3.5vw !important;
        padding: 4vw !important;
        line-height: 1.5 !important;
      }
    }
  }
}
</style>
